import { getSubdomain, fetchWithAuth } from "../../helpers";
import { API_PASSWORD } from "../../config";

export const startDailySession = async () => {
  let subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const rootId = localStorage.getItem("branch_id");

  if (!token) throw new Error("❌ لا يوجد توكن.");
  if (!rootId) throw new Error("❌ لم يتم العثور على branch_id (root_id).");

  if (!subdomain || subdomain === "localhost") {
    subdomain = "test01";
  }

  const apiUrl = `https://${subdomain}.restocash.app/api/create/automatic/daily/session/${rootId}?api_password=Project102$_`;

  console.log("📡 إرسال طلب بدء اليومية إلى:", apiUrl);

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في بدء اليومية:", data);
    throw new Error(data?.message || "❌ فشل في بدء اليومية.");
  }

  console.log("✅ تم بدء اليومية:", data.session);
  return data.session;
};

export const endDailySession = async () => {
  let subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const rootId = localStorage.getItem("branch_id");

  if (!token) throw new Error("❌ لا يوجد توكن.");
  if (!rootId) throw new Error("❌ لم يتم العثور على branch_id (root_id).");

  if (!subdomain || subdomain === "localhost") {
    subdomain = "test01";
  }

  const apiUrl = `https://${subdomain}.restocash.app/api/end/daliy/session/${rootId}?api_password=Project102$_`;

  console.log("📡 إرسال طلب إغلاق اليومية إلى:", apiUrl);

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في إغلاق اليومية:", data);
    throw new Error(data?.message || "❌ فشل في إغلاق اليومية.");
  }

  console.log("✅ تم إغلاق اليومية:", data.session);
  return data.session;
};

// الشيفتات
export const startShift = async (shiftId, rootId) => {
  let subdomain = getSubdomain();
  const token = localStorage.getItem("token");

  if (!token) throw new Error("❌ لا يوجد توكن.");
  if (!rootId) throw new Error("❌ لم يتم العثور على branch_id (root_id).");
  if (!shiftId) throw new Error("❌ لم يتم العثور على معرف الشيفت.");

  if (!subdomain || subdomain === "localhost") {
    subdomain = "test01";
  }

  const apiUrl = `https://${subdomain}.restocash.app/api/start/shift/${rootId}/${shiftId}?api_password=Project102$_`;

  console.log("📡 إرسال طلب بدء الشيفت إلى:", apiUrl);

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في بدء الشيفت:", data);
    throw new Error(data?.message || "❌ فشل في بدء الشيفت.");
  }

  console.log("✅ تم بدء الشيفت:", data.shift);
  return data.shift;
};

export const endShift = async () => {
  let subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const rootId = localStorage.getItem("branch_id"); // Always send root_id from localStorage

  if (!token) throw new Error("❌ لا يوجد توكن.");
  if (!rootId) throw new Error("❌ لم يتم العثور على branch_id (root_id).");

  if (!subdomain || subdomain === "localhost") {
    subdomain = "test01";
  }

  const apiUrl = `https://${subdomain}.restocash.app/api/end/shift/${rootId}?api_password=Project102$_`;

  console.log("📡 إرسال طلب إغلاق الشيفت إلى:", apiUrl);

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في إغلاق الشيفت:", data);
    throw new Error(data?.message || "❌ فشل في إغلاق الشيفت.");
  }

  console.log("✅ تم إغلاق الشيفت بنجاح:", data.message);
  return data.message;
};

export const handoverShift = async (payload) => {
  let subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const rootId = localStorage.getItem("branch_id"); // Always send root_id from localStorage

  if (!token) throw new Error("❌ لا يوجد توكن.");
  if (!rootId) throw new Error("❌ لم يتم العثور على branch_id (root_id).");

  if (!subdomain || subdomain === "localhost") {
    subdomain = "test01";
  }

  payload.root_id = rootId; // Ensure root_id is included in the payload

  const apiUrl = `https://${subdomain}.restocash.app/api/shift/handover?api_password=Project102$_`;

  console.log("📡 إرسال طلب تسليم الشيفت إلى:", apiUrl);

  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في تسليم الشيفت:", data);
    throw new Error(data?.message || "❌ فشل في تسليم الشيفت.");
  }

  console.log("✅ تم تسليم الشيفت بنجاح:", data);
  return data;
};

export const checkActiveDailySession = async () => {
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const rootId = localStorage.getItem("branch_id"); // Always send root_id from localStorage

  if (!token) throw new Error("❌ لا يوجد توكن.");
  if (!rootId) throw new Error("❌ لم يتم العثور على branch_id (root_id).");

  if (!subdomain || subdomain === "localhost") {
    subdomain = "test01";
  }

  const apiUrl = `https://${subdomain}.restocash.app/api/get/active/daliy/session/${rootId}?api_password=Project102$_`;

  console.log("📡 إرسال طلب للتحقق من حالة اليومية إلى:", apiUrl);

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 404) {
      console.error("❌ المسار غير موجود:", apiUrl);
      throw new Error("⚠️ المسار غير موجود أو الرد غير صالح.");
    }

    const text = await response.text();

    let data;
    try {
      data = JSON.parse(text);
    } catch (err) {
      console.error("🚫 الرد غير صالح (HTML بدلاً من JSON):", text);
      throw new Error("⚠️ الرد غير صالح أو المسار غير موجود.");
    }

    if (!response.ok) {
      console.error("❌ فشل في التحقق من حالة اليومية:", data);
      throw new Error(data?.message || "❌ فشل في التحقق من حالة اليومية.");
    }

    console.log("✅ حالة اليومية:", data.status);
    return data.status === 1 ? "active" : "inactive"; // Map status to "active" or "inactive"
  } catch (error) {
    console.error("🔥 خطأ أثناء الاتصال بالسيرفر:", error);
    throw error;
  }
};

export const executeCheckActiveDailyshift = async () => {
  try {
    const subdomain = getSubdomain();
    const rootId = localStorage.getItem("branch_id");
    const token = localStorage.getItem("token"); // ✅ Add token for authorization
    const apiPassword = "Project102$_";

    if (!rootId) throw new Error("❌ لم يتم العثور على branch_id.");

    const apiUrl = `https://${subdomain}.restocash.app/api/get/active/daliy/session/shift/${rootId}?api_password=${apiPassword}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "❌ فشل في التحقق من حالة الشيفت.");
    }

    // status: 1 => active, 0 => inactive
    return data.status === 1 ? "active" : "inactive";
  } catch (error) {
    console.error("❌ خطأ أثناء تنفيذ الدالة:", error.message);
    throw error;
  }
};

export const createShiftTitle = async (rootId, title) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/shift/title?api_password=${API_PASSWORD}`;

  const formData = new FormData();
  formData.append("root_id", rootId);
  formData.append("title", title);

  const response = await fetchWithAuth(
    apiUrl,
    {
      method: "POST",
      body: formData,
    },
    true
  ); // FormData mode

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ API Error:", data);
    throw new Error(data.message || "❌ فشل في إنشاء عنوان الشيفت.");
  }

  console.log("✅ تم إنشاء عنوان الشيفت بنجاح:", data);
  return data.shiftTitle;
};

export const getShiftTitles = async (rootId) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/shift/titles/${rootId}?api_password=${API_PASSWORD}`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ API Error:", data);
    throw new Error(data.message || "❌ فشل في جلب عناوين الشيفتات.");
  }

  console.log("✅ تم جلب عناوين الشيفتات بنجاح:", data.shiftTitles);
  return data.shiftTitles || [];
};

export const getActiveShiftTransactions = async (sessionId) => {
  let subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const root_id = localStorage.getItem("branch_id"); // ✅ جلب root_id من localStorage

  if (!token) throw new Error("❌ لا يوجد توكن.");
  if (!root_id) throw new Error("❌ لم يتم العثور على branch_id (root_id).");

  if (!subdomain || subdomain === "localhost") {
    subdomain = "test01";
  }

  // ✅ استخدم root_id في الرابط
  const apiUrl = `https://${subdomain}.restocash.app/api/get/active/shift/transactions/${root_id}?api_password=Project102$_`;

  console.log("📡 جلب معاملات الشيفت الحالي من:", apiUrl);

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في جلب المعاملات:", data);
    throw new Error(data?.message || "❌ فشل في جلب معاملات الشيفت.");
  }

  console.log("✅ معاملات الشيفت الحالية:", data.transactions || data);
  return data.transactions || data;
};

// إنشاء اليومية تلقائياً (Automatic Daily Session)
export const createAutomaticDailySession = async () => {
  let subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const rootId = localStorage.getItem("branch_id");
  const apiPassword = "Project102$_";

  if (!token) throw new Error("❌ لا يوجد توكن.");
  if (!rootId) throw new Error("❌ لم يتم العثور على branch_id (root_id).");

  if (!subdomain || subdomain === "localhost") {
    subdomain = "test01";
  }

  const apiUrl = `https://${subdomain}.restocash.app/api/create/automatic/daily/session/${rootId}?api_password=${apiPassword}`;

  console.log("📡 إرسال طلب إنشاء اليومية تلقائياً إلى:", apiUrl);

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في إنشاء اليومية تلقائياً:", data);
    throw new Error(data?.message || "❌ فشل في إنشاء اليومية تلقائياً.");
  }

  console.log("✅ تم إنشاء اليومية تلقائياً:", data.session);
  return data.session;
};

// جلب بيانات الشيفت النشط
export const getActiveShiftData = async () => {
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const apiPassword = "Project102$_";
  
  const branchId = localStorage.getItem("branch_id"); // ✅ جلب id الفرع من اللوكال استورج

  const apiUrl = `https://${subdomain}.restocash.app/api/get/active/shift/${branchId}?api_password=${apiPassword}`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في جلب بيانات الشيفت النشط.");
  }

  return data.active_shifts || [];
};

// جلب بيانات اليومية النشطة
export const getActiveDailySessionData = async () => {
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const apiPassword = "Project102$_";
  const branchId = localStorage.getItem("branch_id");

  const apiUrl = `https://${subdomain}.restocash.app/api/get/active/session/${branchId}?api_password=${apiPassword}`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في جلب بيانات اليومية النشطة.");
  }

  return data.data || [];
};

// إنشاء اليومية اليدوية
export const createManualDailySession = async (rootId, sessionDate) => {
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const apiPassword = "Project102$_";

  const apiUrl = `https://${subdomain}.restocash.app/api/create/manual/daily/session?api_password=${apiPassword}`;

  const formData = new FormData();
  formData.append("root_id", rootId);
  formData.append("session_date", sessionDate);

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في إنشاء اليومية اليدوية.");
  }

  return data.session || {};
};

